import * as keys from '../reducers/userProfile/keys';

export const updateProfileImage = loadProfile => ({ // eslint-disable-line
  type: keys.PROFILE_IMAGE,
  payload: loadProfile
});



// WEBPACK FOOTER //
// ./src/actions/userProfile.action.js